import { post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 翻译相关API
export const translationApi = {
  /**
   * 翻译评论内容
   * @param pid - 评论ID
   * @param message - 评论内容（html的内容）
   * @param game_id - 游戏ID
   * @param target_language - 目标语种
   * @returns Promise<ApiResponse>
   */
  translate: (
    pid: number,
    message: string,
    game_id: number,
    target_language: string
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.TRANSLATION,
      API_CONFIG.ACTIONS.DO
    );
    const formData = new FormData();
    formData.append("pid", String(pid));
    formData.append("message", message);
    formData.append("game_id", String(game_id));
    formData.append("target_language", target_language);
    return post<ApiResponse>(url, formData);
  },
};
